import React from 'react';
import './SkeletonLoader.scss';

export function SkeletonLoader({ showSlider = true }) {
  return (
    <div className="SkeletonLoader">
      {showSlider && <div className="SkeletonLoader__item SkeletonLoader__featureSlider SkeletonLoader__item_fw-size">
        <div className="SkeletonLoader__item-bg SkeletonLoader__item-bg_radius"/>
      </div>}

      {Array.from(new Array(15)).map((_, i) => (
        <div className="SkeletonLoader__item" key={i}>
          <div className="SkeletonLoader__item-bg SkeletonLoader__item-bg_radius" />
        </div>
      ))}
    </div>
  );
}
